export function redirectToSameUrlWithoutTab() {
    const url = new URL(window.location.href);
    url.searchParams.delete('tab_id');
    window.location.href = url.toString();
}
